import { default as about_45usQyYyjJjWUzMeta } from "/opt/apps/.build/apps/betobee/app/pages/about-us.vue?macro=true";
import { default as agreementC8z5hrM7DKMeta } from "/opt/apps/.build/apps/betobee/app/pages/agreement.vue?macro=true";
import { default as _91token_93hqJXdpTeHxMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/email-confirm/[request]/[token].vue?macro=true";
import { default as customer5GqRxi7gcrMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/customer.vue?macro=true";
import { default as _91code_93SNHXO6vgOEMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/employee-oauth/[code].vue?macro=true";
import { default as employeeYnCXFek8cnMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/employee.vue?macro=true";
import { default as indexHQnzGNP6xSMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/index.vue?macro=true";
import { default as _91code_93Rp2i6OkNZGMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/reset-password/[code].vue?macro=true";
import { default as indexKguJT7MWXqMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/reset-password/index.vue?macro=true";
import { default as indexsemFxxrwNRMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-in/[flowId]/[magicToken]/index.vue?macro=true";
import { default as indexLxx9ijjKeZMeta } from "/opt/apps/.build/apps/betobee/layers/auth/pages/cabinet/auth/sign-in/index.vue?macro=true";
import { default as indexlPyMuXoENDMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-in/oauth/index.vue?macro=true";
import { default as customerCQWZtAIyP7Meta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/customer.vue?macro=true";
import { default as indexutGEM47D9ZMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/employee/[[companyId]]/index.vue?macro=true";
import { default as verificationvYjYbPU2kFMeta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/employee/[[companyId]]/verification.vue?macro=true";
import { default as index5JIsAZFGD5Meta } from "/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/index.vue?macro=true";
import { default as dashboard4DKDEJECoxMeta } from "/opt/apps/.build/apps/betobee/layers/hr/pages/cabinet/business/dashboard.vue?macro=true";
import { default as indexpb6CmWfJUKMeta } from "/opt/apps/.build/packages/nuxt/layers/hr/pages/cabinet/business/sessions/index.vue?macro=true";
import { default as index62V3G419iFMeta } from "/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/chat/[roomId]/index.vue?macro=true";
import { default as indexay8kPOJ5xXMeta } from "/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/chat/index.vue?macro=true";
import { default as activationVVFOndfFubMeta } from "/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/activation.vue?macro=true";
import { default as payUhqeaRQaEeMeta } from "/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/carts/[id]/pay.vue?macro=true";
import { default as checkouteHCXLgX0ZOMeta } from "/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/[itemId]/checkout.vue?macro=true";
import { default as indexg9XWqTf7StMeta } from "/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/[itemId]/index.vue?macro=true";
import { default as _91_46_46_46filter_93NtSy7vpctJMeta } from "/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/filter/[...filter].vue?macro=true";
import { default as indexMjumezeoABMeta } from "/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/index.vue?macro=true";
import { default as dashboardNjwazV0baAMeta } from "/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/dashboard.vue?macro=true";
import { default as indexRnBkvQ6dCoMeta } from "/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/meetings/[meetingId]/index.vue?macro=true";
import { default as room7apc4d2wcpMeta } from "/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/meetings/[meetingId]/room.vue?macro=true";
import { default as confirmKPprsm8e23Meta } from "/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/[orderId]/confirm.vue?macro=true";
import { default as reschedulej5SICS3IK7Meta } from "/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/sessions/[sessionId]/reschedule.vue?macro=true";
import { default as reviewL2hkE04T4JMeta } from "/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/sessions/[sessionId]/review.vue?macro=true";
import { default as index7ilXmtj8dSMeta } from "/opt/apps/.build/apps/betobee/app/pages/cabinet/settings/index.vue?macro=true";
import { default as contactsXgVCpKfAX9Meta } from "/opt/apps/.build/apps/betobee/app/pages/contacts.vue?macro=true";
import { default as indexfo5tBSQBaSMeta } from "/opt/apps/.build/apps/betobee/app/pages/index.vue?macro=true";
import { default as _91step_93PPAEdLaxrGMeta } from "/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/[id]/[step].vue?macro=true";
import { default as indexqFUss6V2SDMeta } from "/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/[id]/index.vue?macro=true";
import { default as indexPOqZnENdvGMeta } from "/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/index.vue?macro=true";
import { default as success4uzj4V3lxSMeta } from "/opt/apps/.build/apps/betobee/layers/marketplace/pages/orders/[orderId]/success.vue?macro=true";
import { default as privacycFbnW085jkMeta } from "/opt/apps/.build/apps/betobee/app/pages/privacy.vue?macro=true";
import { default as indexTINdpTAunLMeta } from "/opt/apps/.build/apps/betobee/app/pages/surveys/[id]/index.vue?macro=true";
import { default as resultsuKSZGiMBK4Meta } from "/opt/apps/.build/apps/betobee/app/pages/surveys/[id]/results.vue?macro=true";
import { default as wellbeingSvxI0kQvn7Meta } from "/opt/apps/.build/apps/betobee/app/pages/wellbeing.vue?macro=true";
import { default as zhuravel_46anastasiasFWxrvE3BHMeta } from "/opt/apps/.build/apps/betobee/app/pages/zhuravel.anastasia.vue?macro=true";
export default [
  {
    name: "about-us___uk",
    path: "/about-us",
    meta: about_45usQyYyjJjWUzMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "about-us___en",
    path: "/en/about-us",
    meta: about_45usQyYyjJjWUzMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "about-us___es",
    path: "/es/about-us",
    meta: about_45usQyYyjJjWUzMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "about-us___ru",
    path: "/ru/about-us",
    meta: about_45usQyYyjJjWUzMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/about-us.vue").then(m => m.default || m)
  },
  {
    name: "agreement___uk",
    path: "/agreement",
    meta: agreementC8z5hrM7DKMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/agreement.vue").then(m => m.default || m)
  },
  {
    name: "agreement___en",
    path: "/en/agreement",
    meta: agreementC8z5hrM7DKMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/agreement.vue").then(m => m.default || m)
  },
  {
    name: "agreement___es",
    path: "/es/agreement",
    meta: agreementC8z5hrM7DKMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/agreement.vue").then(m => m.default || m)
  },
  {
    name: "agreement___ru",
    path: "/ru/agreement",
    meta: agreementC8z5hrM7DKMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/agreement.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-email-confirm-request-token___uk",
    path: "/cabinet/auth/email-confirm/:request()/:token()",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/email-confirm/[request]/[token].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-email-confirm-request-token___en",
    path: "/en/cabinet/auth/email-confirm/:request()/:token()",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/email-confirm/[request]/[token].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-email-confirm-request-token___es",
    path: "/es/cabinet/auth/email-confirm/:request()/:token()",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/email-confirm/[request]/[token].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-email-confirm-request-token___ru",
    path: "/ru/cabinet/auth/email-confirm/:request()/:token()",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/email-confirm/[request]/[token].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-customer___uk",
    path: "/cabinet/auth/finish-registration/customer",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/customer.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-customer___en",
    path: "/en/cabinet/auth/finish-registration/customer",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/customer.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-customer___es",
    path: "/es/cabinet/auth/finish-registration/customer",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/customer.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-customer___ru",
    path: "/ru/cabinet/auth/finish-registration/customer",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/customer.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-employee-oauth-code___uk",
    path: "/cabinet/auth/finish-registration/employee-oauth/:code()",
    meta: _91code_93SNHXO6vgOEMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/employee-oauth/[code].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-employee-oauth-code___en",
    path: "/en/cabinet/auth/finish-registration/employee-oauth/:code()",
    meta: _91code_93SNHXO6vgOEMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/employee-oauth/[code].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-employee-oauth-code___es",
    path: "/es/cabinet/auth/finish-registration/employee-oauth/:code()",
    meta: _91code_93SNHXO6vgOEMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/employee-oauth/[code].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-employee-oauth-code___ru",
    path: "/ru/cabinet/auth/finish-registration/employee-oauth/:code()",
    meta: _91code_93SNHXO6vgOEMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/employee-oauth/[code].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-employee___uk",
    path: "/cabinet/auth/finish-registration/employee",
    meta: employeeYnCXFek8cnMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/employee.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-employee___en",
    path: "/en/cabinet/auth/finish-registration/employee",
    meta: employeeYnCXFek8cnMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/employee.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-employee___es",
    path: "/es/cabinet/auth/finish-registration/employee",
    meta: employeeYnCXFek8cnMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/employee.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration-employee___ru",
    path: "/ru/cabinet/auth/finish-registration/employee",
    meta: employeeYnCXFek8cnMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/employee.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration___uk",
    path: "/cabinet/auth/finish-registration",
    meta: indexHQnzGNP6xSMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration___en",
    path: "/en/cabinet/auth/finish-registration",
    meta: indexHQnzGNP6xSMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration___es",
    path: "/es/cabinet/auth/finish-registration",
    meta: indexHQnzGNP6xSMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-finish-registration___ru",
    path: "/ru/cabinet/auth/finish-registration",
    meta: indexHQnzGNP6xSMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/finish-registration/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-reset-password-code___uk",
    path: "/cabinet/auth/reset-password/:code()",
    meta: _91code_93Rp2i6OkNZGMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/reset-password/[code].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-reset-password-code___en",
    path: "/en/cabinet/auth/reset-password/:code()",
    meta: _91code_93Rp2i6OkNZGMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/reset-password/[code].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-reset-password-code___es",
    path: "/es/cabinet/auth/reset-password/:code()",
    meta: _91code_93Rp2i6OkNZGMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/reset-password/[code].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-reset-password-code___ru",
    path: "/ru/cabinet/auth/reset-password/:code()",
    meta: _91code_93Rp2i6OkNZGMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/reset-password/[code].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-reset-password___uk",
    path: "/cabinet/auth/reset-password",
    meta: indexKguJT7MWXqMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/reset-password/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-reset-password___en",
    path: "/en/cabinet/auth/reset-password",
    meta: indexKguJT7MWXqMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/reset-password/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-reset-password___es",
    path: "/es/cabinet/auth/reset-password",
    meta: indexKguJT7MWXqMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/reset-password/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-reset-password___ru",
    path: "/ru/cabinet/auth/reset-password",
    meta: indexKguJT7MWXqMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/reset-password/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in-flowId-magicToken___uk",
    path: "/cabinet/auth/sign-in/:flowId()/:magicToken()",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-in/[flowId]/[magicToken]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in-flowId-magicToken___en",
    path: "/en/cabinet/auth/sign-in/:flowId()/:magicToken()",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-in/[flowId]/[magicToken]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in-flowId-magicToken___es",
    path: "/es/cabinet/auth/sign-in/:flowId()/:magicToken()",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-in/[flowId]/[magicToken]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in-flowId-magicToken___ru",
    path: "/ru/cabinet/auth/sign-in/:flowId()/:magicToken()",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-in/[flowId]/[magicToken]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in___uk",
    path: "/cabinet/auth/sign-in",
    meta: indexLxx9ijjKeZMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/auth/pages/cabinet/auth/sign-in/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in___en",
    path: "/en/cabinet/auth/sign-in",
    meta: indexLxx9ijjKeZMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/auth/pages/cabinet/auth/sign-in/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in___es",
    path: "/es/cabinet/auth/sign-in",
    meta: indexLxx9ijjKeZMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/auth/pages/cabinet/auth/sign-in/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in___ru",
    path: "/ru/cabinet/auth/sign-in",
    meta: indexLxx9ijjKeZMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/auth/pages/cabinet/auth/sign-in/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in-oauth___uk",
    path: "/cabinet/auth/sign-in/oauth",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-in/oauth/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in-oauth___en",
    path: "/en/cabinet/auth/sign-in/oauth",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-in/oauth/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in-oauth___es",
    path: "/es/cabinet/auth/sign-in/oauth",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-in/oauth/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-in-oauth___ru",
    path: "/ru/cabinet/auth/sign-in/oauth",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-in/oauth/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-customer___uk",
    path: "/cabinet/auth/sign-up/customer",
    meta: customerCQWZtAIyP7Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/customer.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-customer___en",
    path: "/en/cabinet/auth/sign-up/customer",
    meta: customerCQWZtAIyP7Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/customer.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-customer___es",
    path: "/es/cabinet/auth/sign-up/customer",
    meta: customerCQWZtAIyP7Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/customer.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-customer___ru",
    path: "/ru/cabinet/auth/sign-up/customer",
    meta: customerCQWZtAIyP7Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/customer.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-employee-companyId___uk",
    path: "/cabinet/auth/sign-up/employee/:companyId?",
    meta: indexutGEM47D9ZMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/employee/[[companyId]]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-employee-companyId___en",
    path: "/en/cabinet/auth/sign-up/employee/:companyId?",
    meta: indexutGEM47D9ZMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/employee/[[companyId]]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-employee-companyId___es",
    path: "/es/cabinet/auth/sign-up/employee/:companyId?",
    meta: indexutGEM47D9ZMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/employee/[[companyId]]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-employee-companyId___ru",
    path: "/ru/cabinet/auth/sign-up/employee/:companyId?",
    meta: indexutGEM47D9ZMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/employee/[[companyId]]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-employee-companyId-verification___uk",
    path: "/cabinet/auth/sign-up/employee/:companyId?/verification",
    meta: verificationvYjYbPU2kFMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/employee/[[companyId]]/verification.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-employee-companyId-verification___en",
    path: "/en/cabinet/auth/sign-up/employee/:companyId?/verification",
    meta: verificationvYjYbPU2kFMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/employee/[[companyId]]/verification.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-employee-companyId-verification___es",
    path: "/es/cabinet/auth/sign-up/employee/:companyId?/verification",
    meta: verificationvYjYbPU2kFMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/employee/[[companyId]]/verification.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up-employee-companyId-verification___ru",
    path: "/ru/cabinet/auth/sign-up/employee/:companyId?/verification",
    meta: verificationvYjYbPU2kFMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/employee/[[companyId]]/verification.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up___uk",
    path: "/cabinet/auth/sign-up",
    meta: index5JIsAZFGD5Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up___en",
    path: "/en/cabinet/auth/sign-up",
    meta: index5JIsAZFGD5Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up___es",
    path: "/es/cabinet/auth/sign-up",
    meta: index5JIsAZFGD5Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-auth-sign-up___ru",
    path: "/ru/cabinet/auth/sign-up",
    meta: index5JIsAZFGD5Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/auth/pages/cabinet/auth/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-business-dashboard___uk",
    path: "/cabinet/business/dashboard",
    meta: dashboard4DKDEJECoxMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/hr/pages/cabinet/business/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-business-dashboard___en",
    path: "/en/cabinet/business/dashboard",
    meta: dashboard4DKDEJECoxMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/hr/pages/cabinet/business/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-business-dashboard___es",
    path: "/es/cabinet/business/dashboard",
    meta: dashboard4DKDEJECoxMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/hr/pages/cabinet/business/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-business-dashboard___ru",
    path: "/ru/cabinet/business/dashboard",
    meta: dashboard4DKDEJECoxMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/hr/pages/cabinet/business/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-business-sessions___uk",
    path: "/cabinet/business/sessions",
    meta: indexpb6CmWfJUKMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/hr/pages/cabinet/business/sessions/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-business-sessions___en",
    path: "/en/cabinet/business/sessions",
    meta: indexpb6CmWfJUKMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/hr/pages/cabinet/business/sessions/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-business-sessions___es",
    path: "/es/cabinet/business/sessions",
    meta: indexpb6CmWfJUKMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/hr/pages/cabinet/business/sessions/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-business-sessions___ru",
    path: "/ru/cabinet/business/sessions",
    meta: indexpb6CmWfJUKMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/hr/pages/cabinet/business/sessions/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-chat-roomId___uk",
    path: "/cabinet/chat/:roomId()",
    meta: index62V3G419iFMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/chat/[roomId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-chat-roomId___en",
    path: "/en/cabinet/chat/:roomId()",
    meta: index62V3G419iFMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/chat/[roomId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-chat-roomId___es",
    path: "/es/cabinet/chat/:roomId()",
    meta: index62V3G419iFMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/chat/[roomId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-chat-roomId___ru",
    path: "/ru/cabinet/chat/:roomId()",
    meta: index62V3G419iFMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/chat/[roomId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-chat___uk",
    path: "/cabinet/chat",
    meta: indexay8kPOJ5xXMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/chat/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-chat___en",
    path: "/en/cabinet/chat",
    meta: indexay8kPOJ5xXMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/chat/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-chat___es",
    path: "/es/cabinet/chat",
    meta: indexay8kPOJ5xXMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/chat/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-chat___ru",
    path: "/ru/cabinet/chat",
    meta: indexay8kPOJ5xXMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/chat/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-activation___uk",
    path: "/cabinet/employee/activation",
    meta: activationVVFOndfFubMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/activation.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-activation___en",
    path: "/en/cabinet/employee/activation",
    meta: activationVVFOndfFubMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/activation.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-activation___es",
    path: "/es/cabinet/employee/activation",
    meta: activationVVFOndfFubMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/activation.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-activation___ru",
    path: "/ru/cabinet/employee/activation",
    meta: activationVVFOndfFubMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/activation.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-carts-id-pay___uk",
    path: "/cabinet/employee/carts/:id()/pay",
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/carts/[id]/pay.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-carts-id-pay___en",
    path: "/en/cabinet/employee/carts/:id()/pay",
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/carts/[id]/pay.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-carts-id-pay___es",
    path: "/es/cabinet/employee/carts/:id()/pay",
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/carts/[id]/pay.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-carts-id-pay___ru",
    path: "/ru/cabinet/employee/carts/:id()/pay",
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/carts/[id]/pay.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-itemId-checkout___uk",
    path: "/cabinet/employee/catalog/:itemId()/checkout",
    meta: checkouteHCXLgX0ZOMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/[itemId]/checkout.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-itemId-checkout___en",
    path: "/en/cabinet/employee/catalog/:itemId()/checkout",
    meta: checkouteHCXLgX0ZOMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/[itemId]/checkout.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-itemId-checkout___es",
    path: "/es/cabinet/employee/catalog/:itemId()/checkout",
    meta: checkouteHCXLgX0ZOMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/[itemId]/checkout.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-itemId-checkout___ru",
    path: "/ru/cabinet/employee/catalog/:itemId()/checkout",
    meta: checkouteHCXLgX0ZOMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/[itemId]/checkout.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-itemId___uk",
    path: "/cabinet/employee/catalog/:itemId()",
    meta: indexg9XWqTf7StMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/[itemId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-itemId___en",
    path: "/en/cabinet/employee/catalog/:itemId()",
    meta: indexg9XWqTf7StMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/[itemId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-itemId___es",
    path: "/es/cabinet/employee/catalog/:itemId()",
    meta: indexg9XWqTf7StMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/[itemId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-itemId___ru",
    path: "/ru/cabinet/employee/catalog/:itemId()",
    meta: indexg9XWqTf7StMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/[itemId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-filter-filter___uk",
    path: "/cabinet/employee/catalog/filter/:filter(.*)*",
    meta: _91_46_46_46filter_93NtSy7vpctJMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/filter/[...filter].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-filter-filter___en",
    path: "/en/cabinet/employee/catalog/filter/:filter(.*)*",
    meta: _91_46_46_46filter_93NtSy7vpctJMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/filter/[...filter].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-filter-filter___es",
    path: "/es/cabinet/employee/catalog/filter/:filter(.*)*",
    meta: _91_46_46_46filter_93NtSy7vpctJMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/filter/[...filter].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog-filter-filter___ru",
    path: "/ru/cabinet/employee/catalog/filter/:filter(.*)*",
    meta: _91_46_46_46filter_93NtSy7vpctJMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/filter/[...filter].vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog___uk",
    path: "/cabinet/employee/catalog",
    meta: indexMjumezeoABMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog___en",
    path: "/en/cabinet/employee/catalog",
    meta: indexMjumezeoABMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog___es",
    path: "/es/cabinet/employee/catalog",
    meta: indexMjumezeoABMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-catalog___ru",
    path: "/ru/cabinet/employee/catalog",
    meta: indexMjumezeoABMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-dashboard___uk",
    path: "/cabinet/employee/dashboard",
    meta: dashboardNjwazV0baAMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-dashboard___en",
    path: "/en/cabinet/employee/dashboard",
    meta: dashboardNjwazV0baAMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-dashboard___es",
    path: "/es/cabinet/employee/dashboard",
    meta: dashboardNjwazV0baAMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-employee-dashboard___ru",
    path: "/ru/cabinet/employee/dashboard",
    meta: dashboardNjwazV0baAMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/employee/pages/cabinet/employee/dashboard.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-meetings-meetingId___uk",
    path: "/cabinet/meetings/:meetingId()",
    meta: indexRnBkvQ6dCoMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/meetings/[meetingId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-meetings-meetingId___en",
    path: "/en/cabinet/meetings/:meetingId()",
    meta: indexRnBkvQ6dCoMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/meetings/[meetingId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-meetings-meetingId___es",
    path: "/es/cabinet/meetings/:meetingId()",
    meta: indexRnBkvQ6dCoMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/meetings/[meetingId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-meetings-meetingId___ru",
    path: "/ru/cabinet/meetings/:meetingId()",
    meta: indexRnBkvQ6dCoMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/meetings/[meetingId]/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-meetings-meetingId-room___uk",
    path: "/cabinet/meetings/:meetingId()/room",
    meta: room7apc4d2wcpMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/meetings/[meetingId]/room.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-meetings-meetingId-room___en",
    path: "/en/cabinet/meetings/:meetingId()/room",
    meta: room7apc4d2wcpMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/meetings/[meetingId]/room.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-meetings-meetingId-room___es",
    path: "/es/cabinet/meetings/:meetingId()/room",
    meta: room7apc4d2wcpMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/meetings/[meetingId]/room.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-meetings-meetingId-room___ru",
    path: "/ru/cabinet/meetings/:meetingId()/room",
    meta: room7apc4d2wcpMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/chat/pages/cabinet/meetings/[meetingId]/room.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-orderId-confirm___uk",
    path: "/cabinet/orders/:orderId()/confirm",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/[orderId]/confirm.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-orderId-confirm___en",
    path: "/en/cabinet/orders/:orderId()/confirm",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/[orderId]/confirm.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-orderId-confirm___es",
    path: "/es/cabinet/orders/:orderId()/confirm",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/[orderId]/confirm.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-orderId-confirm___ru",
    path: "/ru/cabinet/orders/:orderId()/confirm",
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/[orderId]/confirm.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-sessions-sessionId-reschedule___uk",
    path: "/cabinet/orders/sessions/:sessionId()/reschedule",
    meta: reschedulej5SICS3IK7Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/sessions/[sessionId]/reschedule.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-sessions-sessionId-reschedule___en",
    path: "/en/cabinet/orders/sessions/:sessionId()/reschedule",
    meta: reschedulej5SICS3IK7Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/sessions/[sessionId]/reschedule.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-sessions-sessionId-reschedule___es",
    path: "/es/cabinet/orders/sessions/:sessionId()/reschedule",
    meta: reschedulej5SICS3IK7Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/sessions/[sessionId]/reschedule.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-sessions-sessionId-reschedule___ru",
    path: "/ru/cabinet/orders/sessions/:sessionId()/reschedule",
    meta: reschedulej5SICS3IK7Meta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/sessions/[sessionId]/reschedule.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-sessions-sessionId-review___uk",
    path: "/cabinet/orders/sessions/:sessionId()/review",
    meta: reviewL2hkE04T4JMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/sessions/[sessionId]/review.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-sessions-sessionId-review___en",
    path: "/en/cabinet/orders/sessions/:sessionId()/review",
    meta: reviewL2hkE04T4JMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/sessions/[sessionId]/review.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-sessions-sessionId-review___es",
    path: "/es/cabinet/orders/sessions/:sessionId()/review",
    meta: reviewL2hkE04T4JMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/sessions/[sessionId]/review.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-orders-sessions-sessionId-review___ru",
    path: "/ru/cabinet/orders/sessions/:sessionId()/review",
    meta: reviewL2hkE04T4JMeta || {},
    component: () => import("/opt/apps/.build/packages/nuxt/layers/marketplace/pages/cabinet/orders/sessions/[sessionId]/review.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-settings___uk",
    path: "/cabinet/settings",
    meta: index7ilXmtj8dSMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/cabinet/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-settings___en",
    path: "/en/cabinet/settings",
    meta: index7ilXmtj8dSMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/cabinet/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-settings___es",
    path: "/es/cabinet/settings",
    meta: index7ilXmtj8dSMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/cabinet/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "cabinet-settings___ru",
    path: "/ru/cabinet/settings",
    meta: index7ilXmtj8dSMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/cabinet/settings/index.vue").then(m => m.default || m)
  },
  {
    name: "contacts___uk",
    path: "/contacts",
    meta: contactsXgVCpKfAX9Meta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contacts___en",
    path: "/en/contacts",
    meta: contactsXgVCpKfAX9Meta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contacts___es",
    path: "/es/contacts",
    meta: contactsXgVCpKfAX9Meta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "contacts___ru",
    path: "/ru/contacts",
    meta: contactsXgVCpKfAX9Meta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/contacts.vue").then(m => m.default || m)
  },
  {
    name: "index___uk",
    path: "/",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "matching-id-step___uk",
    path: "/matching/:id()/:step()",
    meta: _91step_93PPAEdLaxrGMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/[id]/[step].vue").then(m => m.default || m)
  },
  {
    name: "matching-id-step___en",
    path: "/en/matching/:id()/:step()",
    meta: _91step_93PPAEdLaxrGMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/[id]/[step].vue").then(m => m.default || m)
  },
  {
    name: "matching-id-step___es",
    path: "/es/matching/:id()/:step()",
    meta: _91step_93PPAEdLaxrGMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/[id]/[step].vue").then(m => m.default || m)
  },
  {
    name: "matching-id-step___ru",
    path: "/ru/matching/:id()/:step()",
    meta: _91step_93PPAEdLaxrGMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/[id]/[step].vue").then(m => m.default || m)
  },
  {
    name: "matching-id___uk",
    path: "/matching/:id()",
    meta: indexqFUss6V2SDMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "matching-id___en",
    path: "/en/matching/:id()",
    meta: indexqFUss6V2SDMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "matching-id___es",
    path: "/es/matching/:id()",
    meta: indexqFUss6V2SDMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "matching-id___ru",
    path: "/ru/matching/:id()",
    meta: indexqFUss6V2SDMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "matching___uk",
    path: "/matching",
    meta: indexPOqZnENdvGMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/index.vue").then(m => m.default || m)
  },
  {
    name: "matching___en",
    path: "/en/matching",
    meta: indexPOqZnENdvGMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/index.vue").then(m => m.default || m)
  },
  {
    name: "matching___es",
    path: "/es/matching",
    meta: indexPOqZnENdvGMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/index.vue").then(m => m.default || m)
  },
  {
    name: "matching___ru",
    path: "/ru/matching",
    meta: indexPOqZnENdvGMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/matching/index.vue").then(m => m.default || m)
  },
  {
    name: "orders-orderId-success___uk",
    path: "/orders/:orderId()/success",
    meta: success4uzj4V3lxSMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/orders/[orderId]/success.vue").then(m => m.default || m)
  },
  {
    name: "orders-orderId-success___en",
    path: "/en/orders/:orderId()/success",
    meta: success4uzj4V3lxSMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/orders/[orderId]/success.vue").then(m => m.default || m)
  },
  {
    name: "orders-orderId-success___es",
    path: "/es/orders/:orderId()/success",
    meta: success4uzj4V3lxSMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/orders/[orderId]/success.vue").then(m => m.default || m)
  },
  {
    name: "orders-orderId-success___ru",
    path: "/ru/orders/:orderId()/success",
    meta: success4uzj4V3lxSMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/layers/marketplace/pages/orders/[orderId]/success.vue").then(m => m.default || m)
  },
  {
    name: "privacy___uk",
    path: "/privacy",
    meta: privacycFbnW085jkMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___en",
    path: "/en/privacy",
    meta: privacycFbnW085jkMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___es",
    path: "/es/privacy",
    meta: privacycFbnW085jkMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "privacy___ru",
    path: "/ru/privacy",
    meta: privacycFbnW085jkMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/privacy.vue").then(m => m.default || m)
  },
  {
    name: "surveys-id___uk",
    path: "/surveys/:id()",
    meta: indexTINdpTAunLMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/surveys/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "surveys-id___en",
    path: "/en/surveys/:id()",
    meta: indexTINdpTAunLMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/surveys/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "surveys-id___es",
    path: "/es/surveys/:id()",
    meta: indexTINdpTAunLMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/surveys/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "surveys-id___ru",
    path: "/ru/surveys/:id()",
    meta: indexTINdpTAunLMeta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/surveys/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "surveys-id-results___uk",
    path: "/surveys/:id()/results",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/surveys/[id]/results.vue").then(m => m.default || m)
  },
  {
    name: "surveys-id-results___en",
    path: "/en/surveys/:id()/results",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/surveys/[id]/results.vue").then(m => m.default || m)
  },
  {
    name: "surveys-id-results___es",
    path: "/es/surveys/:id()/results",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/surveys/[id]/results.vue").then(m => m.default || m)
  },
  {
    name: "surveys-id-results___ru",
    path: "/ru/surveys/:id()/results",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/surveys/[id]/results.vue").then(m => m.default || m)
  },
  {
    name: "wellbeing___uk",
    path: "/wellbeing",
    meta: wellbeingSvxI0kQvn7Meta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/wellbeing.vue").then(m => m.default || m)
  },
  {
    name: "wellbeing___en",
    path: "/en/wellbeing",
    meta: wellbeingSvxI0kQvn7Meta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/wellbeing.vue").then(m => m.default || m)
  },
  {
    name: "wellbeing___es",
    path: "/es/wellbeing",
    meta: wellbeingSvxI0kQvn7Meta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/wellbeing.vue").then(m => m.default || m)
  },
  {
    name: "wellbeing___ru",
    path: "/ru/wellbeing",
    meta: wellbeingSvxI0kQvn7Meta || {},
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/wellbeing.vue").then(m => m.default || m)
  },
  {
    name: "zhuravel.anastasia___uk",
    path: "/zhuravel.anastasia",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/zhuravel.anastasia.vue").then(m => m.default || m)
  },
  {
    name: "zhuravel.anastasia___en",
    path: "/en/zhuravel.anastasia",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/zhuravel.anastasia.vue").then(m => m.default || m)
  },
  {
    name: "zhuravel.anastasia___es",
    path: "/es/zhuravel.anastasia",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/zhuravel.anastasia.vue").then(m => m.default || m)
  },
  {
    name: "zhuravel.anastasia___ru",
    path: "/ru/zhuravel.anastasia",
    component: () => import("/opt/apps/.build/apps/betobee/app/pages/zhuravel.anastasia.vue").then(m => m.default || m)
  }
]